<div>
  <td-wb-dropdown [ngModel]="accountGroup()"
                  [panelMaxHeight]="310"
                  [placeholder]="'tdWb.components.accountGroupSelector.PLACEHOLDER' | tdWbTranslate "
                  [ariaLabel]="'tdWb.components.accountGroupSelector.ACCOUNT_GROUP_ARIA' | tdWbTranslate"
                  name="accountGroupDropdown"
                  (ngModelChange)="onModelChange($event)">
    <td-wb-dropdown-toggle>
      @if (accountGroup() !== undefined) {
        <td-wb-account-group-label [accountGroup]="accountGroup()" />
      }
    </td-wb-dropdown-toggle>
    @for (group of accountGroups(); track group) {
      <td-wb-dropdown-item [value]="group">
        <td-wb-account-group-label [accountGroup]="group" />
      </td-wb-dropdown-item>
    }
  </td-wb-dropdown>
</div>
